import React from 'react';
import {classes, style} from './doppe-action-type-widget-content-sections.st.css';
import {
    DoppeActionTypeWidgetCollapsableContainer
} from '../doppe-action-type-widget-collapsable-container/doppe-action-type-widget-collapsable-container';
import {
    DoppeActionContentSection,
    DoppeActionContentSectionLayoutType
} from '../../client-server-common/types/doppe-action-content-section';
import {
    doppeViewerActionContentSectionTypeResolveContent
} from '../../doppe-sdk/doppe-viewer-action-context/doppe-viewer-action-context-utils';
import {evaluateFunction} from '@wix/devzai-utils-common';
import {IDoppeViewerActionContext} from '../../doppe-sdk';

export const DoppeActionTypeWidgetContentSections = React.memo(function DoppeActionTypeWidgetContentSections(props: DoppeActionTypeWidgetContentSections.Props) {
    const {
        rootActionContext,
        contentSections,
        withInnerPadding = false,
        hasButtons,
        className,
        ...htmlAttributes
    } = props;

    const visibleSections = contentSections.filter(item => item.isVisible);

    if (visibleSections.length === 0) {
        return null;
    }

    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, {
                withInnerPadding: withInnerPadding,
                hasButtons: hasButtons
            },className)}
        >
            {visibleSections.map(contentSection => {

                const {
                    isOpenedByDefault,
                    hideTitle,
                    isCollapsable
                } = evaluateFunction(() => {
                    if (contentSection.layoutSettings.type === DoppeActionContentSectionLayoutType.Inline) {
                        return {
                            isOpenedByDefault: true,
                            hideTitle: contentSection.layoutSettings.hideHeader,
                            isCollapsable: false
                        }
                    }
                    else {
                        return {
                            isOpenedByDefault: contentSection.layoutSettings.isOpenByDefault,
                            hideTitle: false,
                            isCollapsable: true
                        }
                    }
                })

                return (
                    <DoppeActionTypeWidgetCollapsableContainer
                        withInnerPadding={withInnerPadding}
                        title={contentSection.title}
                        isCollapsable={isCollapsable}
                        isOpenedByDefault={isOpenedByDefault}
                        hideTitle={hideTitle}
                        key={contentSection.id}
                        className={style(classes.contentSection, {})}
                    >
                        {doppeViewerActionContentSectionTypeResolveContent(contentSection, rootActionContext)}
                    </DoppeActionTypeWidgetCollapsableContainer>
                )
            })}
        </div>
    );
});

export namespace DoppeActionTypeWidgetContentSections {

    export interface Props extends React.HTMLAttributes<any> {
        rootActionContext: IDoppeViewerActionContext;
        contentSections: DoppeActionContentSection[];
        withInnerPadding?: boolean;
        hasButtons?: boolean;
    }
}
